export const environment = {
  production: true,
  buildId: '2616849446218051',
  configFile: 'config.json',
};
